<template>
  <div v-loading="fullScreenLoading" element-loading-text="正在登陆，请稍等...">
    <div :class="'toolItem toolItem-' + theme + ' actived'">
      手机号动态码登录
    </div>
    <div class="el-input-div">
      <el-input
        class="mgtb"
        placeholder="请输入手机号"
        v-model="phone"
      >
        <template v-slot:prefix>
          <i class="iconfont icon-zhanghao"></i>
        </template>
      </el-input>
    </div>
    <div class="verify-div" v-if="slideIsshow">
      <div class="slide-verify-div-box">
        <div class="slide-verify-title">
        <span>请完成安全验证码</span>
        <span @click="slideIsshow = false;slideBtnIsshow = true">x</span>
        </div>
        <div class="slide-verify-box">
          <slide-verify 
            v-if="slideIsshow"
            slider-text="拖动做左边滑块完成上方拼图"
            @success='onSuccess'
            @fail="onFail"
          ></slide-verify>
        </div>
      </div>
      <div class="mask" @click="slideIsshow = false;slideBtnIsshow = true"></div>
    </div>
    
    <!-- 滑动验证码 -->
    <el-button-group style="width: 100%;">
      <el-button v-show="slideBtnIsshow" class="verifyBtn mgtb" @click="showSlide" type="primary">点击完成验证</el-button>
      <el-button v-show="slideSuccessBtn" class="SuccessBtn mgtb"  type="primary">
        <svg t="1652076018727" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1898" width="19" height="19"><path d="M512 0C228.430769 0 0 228.430769 0 512s228.430769 512 512 512 512-228.430769 512-512S795.569231 0 512 0z m0 945.230769C271.753846 945.230769 78.769231 752.246154 78.769231 512S271.753846 78.769231 512 78.769231s433.230769 192.984615 433.230769 433.230769-192.984615 433.230769-433.230769 433.230769z" p-id="1899" fill="#43BF97"></path><path d="M716.8 330.830769l-208.738462 248.123077c-15.753846 15.753846-43.323077 19.692308-59.076923 7.876923L299.323077 472.615385c-15.753846-11.815385-43.323077-7.876923-55.138462 7.876923-11.815385 15.753846-7.876923 43.323077 7.876923 55.138461l149.661539 114.215385c19.692308 15.753846 47.261538 23.630769 74.830769 23.630769 35.446154 0 70.892308-15.753846 94.523077-43.323077l208.738462-248.123077c15.753846-15.753846 11.815385-43.323077-3.938462-55.138461-19.692308-15.753846-43.323077-15.753846-59.076923 3.938461z" p-id="1900" fill="#43BF97"></path></svg>
        验证成功
      </el-button>
    </el-button-group>
    <div class="el-input-div">
      <el-input
        type="text"
        v-model="validcode"
        placeholder="请输入短信验证码"
      >
        <template #prefix>
          <i class="iconfont icon-mima1"></i>
        </template>
        <template #suffix>
          <span class="verification-img">
            <div :class="'getCode getCode-' + theme" @click="onMsmCode" v-if="verificationCount === 0">
              获取验证码
            </div>
            <div class="codeSecond" v-else>{{ verificationCount }}秒后重新获取</div>
          </span>
        </template>
      </el-input>
    </div>    
    <!-- 登录 -->
    <el-button :class="'loginBtn mgtb loginBtn-' + theme" @click="loginGo" type="primary">登 录</el-button>
    
  </div> 
</template>

<script>
import { iphone } from '@/util/util'
import { baseurl } from '@/port/common.js'
import { getaccesstoken, getloginsmsvalidcode, smsvalidcodemultipleaccountslogin } from "@/port/pages/login";
import { ElMessage } from 'element-plus'
export default {
  props: {
    //- 主题色
    theme: {
      type: String,
      default: ''
    },
    isAddUser: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      //- 60s计时
      baseurl: baseurl(),
      verificationCount: 0,
      countTimeFun: null,
      phone: "",
      captcha: "",
      validcode: "",
      //- 图形验证码随机值
      captchatoken: "",
      //- 窗口加载显示
      fullScreenLoading: false,
      // 滑动验证码显示
      slideIsshow: false,
      // 滑动验证码按钮显示
      slideBtnIsshow: true,
      // 滑动验证成功后的提示
      slideSuccessBtn: false,
      // 滑动验证的返回
      isVerify: false,
      moveLength: '',
      imagecaptchatoken: ''
    };
  },
  mounted () {
    this.getCaptcha();
  },
  methods: {
    //- 获取图片验证码
    getCaptcha () {
      this.captchatoken = (Math.random() * 10).toString().slice(-6);
    },
    // 显示滑动验证码
    showSlide(){
      if (!iphone(this.phone)) {
        ElMessage({
          type: 'error',
          message: '请输入正确的手机号'
        })
        return false;
      }
      console.log(this.captchatoken);
      this.slideIsshow = !this.slideIsshow
      this.slideBtnIsshow = false
    },
    // 滑块验证码的回调
    onSuccess(e){
      console.log(e);
      this.imagecaptchatoken = e.imagecaptchatoken
      this.moveLength = e.moveLength
      this.slideIsshow = false
      this.slideSuccessBtn = true
      this.isVerify = true
    },
    onFail(){

    },
    onRefresh(){
        console.log('刷新');
    },
    //- 获取手机验证码
    onMsmCode () {
     
      let self = this;
      if (!iphone(self.phone)) {
        ElMessage({
          type: 'error',
          message: '手机号输入不正确'
        })
        return false;
      }
      if(!this.isVerify){
        ElMessage({
          type: 'error',
          message: '请完成拼图验证'
        })
        return false;
      }
      let data = {
        imagecaptchatoken: this.imagecaptchatoken,
        phone: this.phone,
        moveLength: this.moveLength
      };
      // 走个接口
      getloginsmsvalidcode(data)
        .then(res => {
          console.log(data);
          console.log(res);
          if (res.code == 0) {
            self.verificationCount = 60;
            self.setTimeFun(60);
          } else {
            ElMessage({
              type: 'error',
              message: res.msg
            })
          }
        })
        .catch(() => { this.fullScreenLoading = false });
      //如果接口请求失败
    },
    //- 设置60s定时器
    setTimeFun (e) {
      let self = this;
      this.countTimeFun = setTimeout(function () {
        if (e > 0) {
          let count = e - 1;
          self.verificationCount = count;
          self.setTimeFun(count);
        } else {
          clearTimeout(self.countTimeFun);
          self.countTimeFun = null;
          self.verificationCount = 0;
        }
      }, 1000);
    },
    //- 清除60s定时器
    onClearTimeout () {
      let self = this;
      clearTimeout(self.countTimeFun);
      self.countTimeFun = null;
      self.verificationCount = 0;
    },
    //- 检测数据格式
    onValidate (key) {
      if (!iphone(this.phone)) {
        ElMessage({
          type: 'error',
          message: '手机号输入不正确'
        })
        return false;
      } else if (this.validcode.length === 0 && key) {
        ElMessage({
          type: 'error',
          message: '请输入短信验证码'
        })
        return false;
      } else if(!this.isVerify){
        ElMessage({
          type: 'error',
          message: '请完成拼图验证'
        })
        return false;
      } else {
        return true;
      }
    },
    //- 登录
    async loginGo () {
      if (!this.onValidate(true)) {
        return false;
      }
      this.$emit("onclearStorage");
      this.fullScreenLoading = true;
      let date = {
        imagecaptchatoken: this.imagecaptchatoken,
        phone: this.phone,
        moveLength: this.moveLength,
        validcode: this.validcode
      };
      const res = await smsvalidcodemultipleaccountslogin(date)
      if (res.data.length === 0) {
        ElMessage({
          type: 'error',
          message: '用户不存在'
        })
      } else if (res.data.length === 1) {
          if (res.code === 0) {
            this.$store.state.postUrl = [];
            if(Object.prototype.hasOwnProperty.call(res.data, 'listschool')){
              res.data.schoolMsg = res.data.listschool[0];
              localStorage.setItem("userMsg", JSON.stringify(res.data));
              this.loginToken(
                res.data.listschool[0].schoolId,
                res.data.userId,
                this.validcode
              );
            }
            else{
              res.data[0].schoolMsg = res.data[0].listschool[0];
              localStorage.setItem("userMsg", JSON.stringify(res.data[0]));
              this.loginToken(
                res.data[0].listschool[0].schoolId,
                res.data[0].userId,
                this.validcode
              );
            }
            
          } else {
            this.fullScreenLoading = false;
            ElMessage({
              type: 'error',
              message: res.msg
            })
          }
      } else if (res.data.length > 1) {
        this.fullScreenLoading = false
        const list = res.data.map(item => {
          return {
            avatar: item.avatar,
            username: item.realname,
            userId: item.userId,
            sex: item.sex,
            usertype: item.usertype
          }
        })
        this.$emit('select-user', list)
      }
    },
    //- 获取token
    loginToken (schoolId, openId, accesstoken) {
      let date = {
        schoolId: schoolId,
        openId: openId,
        accesstoken: accesstoken
      };
      getaccesstoken(date)
        .then(res => {
          if (res.code === 0) {
            if (Number(res.data.login) === 0 || res.data.login === "" || res.data.resetpwd) {
              //- 该场景不会进入
              localStorage.setItem(
                "user",
                JSON.stringify({ apiurl: res.data.apiurl })
              );
              let val = {
                title: "重置密码",
                bottom: "确定",
                origin: "renewPaw",
                name: res.data.name,
                res: res
              };
              this.$emit("forgetPassword", val);
              this.fullScreenLoading = false;
              return false;
            } else {
              localStorage.setItem("user", JSON.stringify(res.data));
              document.cookie = "accesstoken=" + res.data.accesstoken + ";path=/";
              this.$router.push({ path: "/index" });
            }
          } else {
            this.fullScreenLoading = false;
            ElMessage({
              type: 'error',
              message: res.msg
            })
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  
};
</script>

<style scoped lang="scss">
@import './common.scss';
.toolItem {
    flex: 1;
    margin-top: 12px;
    margin-bottom: 42px;
    text-align: center;
    font-size: 16px;
    font-family: MicrosoftYaHei;;
    position: relative;
    &.actived {
      &::after {
        content: "";
        position: absolute;
        left: 31%;
        top: 150%;
        width: 38.5%;
        height: 4px;
        border-radius: 18px;
    }
  }
}
.toolItem-blue {
  color: #3B7CE6;
  &.actived {
    color: #4e86ff;
    &::after {
      background-color: #4e86ff;
    }
  }
}
.toolItem-red {
  color: #E62E19;
  &.actived {
    color: #E62E19;
    &::after {
      background-color: #E62E19;
    }
  }
}
.toolItem-green {
  color: #0EA15F;
  &.actived {
    color: #0EA15F;
    &::after {
      background-color: #0EA15F;
    }
  }
}
::v-deep .el-input__prefix {
  left: 9px;
}
::v-deep .el-input-div {
  margin: 0 0 20px 0;
  width: 100%;
  display: inline-block;

  &:nth-child(1) {
    margin-top: 40px;
  }
  .captchaInput {
    display: inline-block;
  }
  .verification-img {
    display: inline-block;
    vertical-align: top;
    position: relative;
    .getCode {
      cursor: pointer;
      font-size: 14px;
    }
    .getCode-blue {
      color: #4e86ff;
    }
    .getCode-red {
      color: #E62E19;
    }
    .getCode-green {
      color: #0EA15F;
    }
    .getCode::before{
      content: '';
      display: inline-block;
      position: absolute;
      z-index: 999;
      top: 6px;
      left: -7px;
      height: 19px;
      width: 1px;
      background-color: #D8D8D8;
    }
    .codeSecond {
      color: #999999;
      font-size: 14px;
    }
    .codeSecond::before{
      content: '';
      display: inline-block;
      position: absolute;
      z-index: 999;
      top: 7px;
      left: -10px;
      height: 19px;
      width: 1px;
      background-color: #D8D8D8;
    }
  }
  
}
.loginBtn {
  width: 100%;
  border-radius: 30px !important;
  height: 40px;
  color: #ffffff;
  margin: 0;
}
.loginBtn-blue {
  background: #4e86ff;
  border-color: #4e86ff;
}
.loginBtn-red {
  background: #E62E19;
  border-color: #E62E19;
}
.loginBtn-green {
  background: #0EA15F;
  border-color: #0EA15F;
}
</style>
